import React from 'react';
import { isString } from '@brg/is';
import { AuthXService } from '@brg/auth';
import { Spinner } from '@brg/controls';
import { SpinnerWrapper } from './styled';
import LoadingPage from 'shared/pages/loading/LoadingPage';

export class LoginView extends React.Component<any, any> {
    // Данный компонент никогда не должен перерисовываться вне зависимости ни от чего!
    shouldComponentUpdate(nextProps: Readonly<any>, nextState: Readonly<any>, nextContext: any): boolean {
        return false;
    }

    /**
     * При отрисовке компонента
     */
    componentDidMount(): void {
        const uri = isString(localStorage.getItem('redirectUri')) ? localStorage.getItem('redirectUri') ?? '/' : '/';
        localStorage.setItem('redirectUri', '');
        
        const userManager = AuthXService.createUserManager();

        userManager.signinRedirectCallback()
            .then(() => {                
                window.location.href = uri;
            })
            .catch((error) => {
                console.error('Error during signin redirect callback', error);
                window.location.href = '/';
            });
    }

    render() {
        return <div>
            <LoadingPage/>
            <SpinnerWrapper>
                <Spinner size={100} color='silver' width={1.5} />
            </SpinnerWrapper>
        </div>;
    }
}
import React from 'react';
import { isString } from '@brg/is';
import { AuthXService } from '@brg/auth';
import { Spinner } from '@brg/controls';
import { SpinnerWrapper } from './styled';
import LoadingPage from 'shared/pages/loading/LoadingPage';

export class LoginView extends React.Component<any, any> {
    // Данный компонент никогда не должен перерисовываться вне зависимости ни от чего!
    shouldComponentUpdate(nextProps: Readonly<any>, nextState: Readonly<any>, nextContext: any): boolean {
        return false;
    }

    /**
     * При отрисовке компонента
     */
    componentDidMount(): void {
        const uri = isString(localStorage.getItem('redirectUri')) ? localStorage.getItem('redirectUri') ?? '/' : '/';
        localStorage.setItem('redirectUri', '');
        
        const userManager = AuthXService.createUserManager();

        userManager.signinRedirectCallback()
            .then(() => {                
                window.location.href = uri;
            })
            .catch((error) => {
                console.error('Error during signin redirect callback', error);
                window.location.href = '/';
            });
    }

    render() {
        return <div>
            <LoadingPage/>
            <SpinnerWrapper>
                <Spinner size={100} color='silver' width={1.5} />
            </SpinnerWrapper>
        </div>;
    }
}
